import { render, staticRenderFns } from "./RefsPersonGroup.vue?vue&type=template&id=700e63ac&scoped=true"
import script from "./RefsPersonGroup.vue?vue&type=script&lang=ts"
export * from "./RefsPersonGroup.vue?vue&type=script&lang=ts"
import style0 from "./RefsPersonGroup.vue?vue&type=style&index=0&id=700e63ac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e63ac",
  null
  
)

export default component.exports